import { render, staticRenderFns } from "./MobileBottomMenu.vue?vue&type=template&id=017a31ba&scoped=true&"
import script from "./MobileBottomMenu.vue?vue&type=script&lang=js&"
export * from "./MobileBottomMenu.vue?vue&type=script&lang=js&"
import style0 from "./MobileBottomMenu.vue?vue&type=style&index=0&id=017a31ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017a31ba",
  null
  
)

export default component.exports